export default {
  labels: {
    page: 'Page {{current}} sur {{total}}',
    no_file_specified: 'Aucun fichier spécifié',
  },
  buttons: {
    previous: 'Précédent',
    next: 'Suivant',
  },
};
